import React, { useContext, useEffect, useState } from 'react'
import { getImages } from '../Common/const'
import { motion } from "framer-motion";
import UseScrollReveal from '../Common/UseScrollReveal';
import ModalLayout from '../Common/ModalLayout';
import BookAppointmentModal from '../Components/Service/BookAppointmentModal';
import { useLocation } from 'react-router-dom';
import SeoMeta from '../Common/SeoMeta';
import { VehicleContext } from '../Context/VehicleContext';

const Service = () => {
    const { getCMSData } = useContext(VehicleContext);
    const [cmsData, setCMSData] = useState({});
    const getPageData = async () => {
        setCMSData(await getCMSData('service'));
    }
    useEffect(() => {
        getPageData();
    }, []);
    const getCMSValue = (field) => {
        return field in cmsData ? cmsData[field] : "";
    }
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const handleMouseMove = (e) => {
        const { clientX, clientY, currentTarget } = e;
        const { left, top, width, height } = currentTarget.getBoundingClientRect();
        const x = ((clientX - left) / width - 2) * 20;
        const y = ((clientY - top) / height - 1) * 20;
        const bgX = ((clientX - left) / width - 5) * 30;
        const bgY = ((clientY - top) / height - 0.5) * 30;
        setPosition({ x, y, bgX, bgY });
    };
    UseScrollReveal()
    // 
    const [openBookAppointment, setOpenBookAppointment] = useState(false);
    const handleBookAppointment = () => {
        setOpenBookAppointment(true);
        document.body.classList.add('body-overflow');
    }
    const closeBookAppointment = () => {
        setOpenBookAppointment(false)
        document.body.classList.remove('body-overflow');
    }
    // Open Direct Modal
    const location = useLocation();
    useEffect(() => {
        if (location.state?.openModal) {
            setOpenBookAppointment(true);
        }
    }, [location.state]);
    return (
        <>
            <SeoMeta
                title="Exotic Car Service & Repair in Tampa, FL | EEC"
                description="Looking for car service in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
                keywords=""
                ogTitle="Exotic Car Service & Repair in Tampa, FL | EEC"
                ogDescription="Looking for car service in Tampa? European Exotic Center can help with everything from oil changes to exhaust repair."
            />
            <section className="common-banner-wrap">
                <img src={getImages('service-hero.jpg')} alt='hero' />
                <div className="container">
                    <div className='common-banner-pos pt-140 text-center'>
                        <h1 className='banner-lg-title text-uppercase wow reveal fadeInUp'>{getCMSValue('serviceMainHeading')}</h1>
                        <div className='my-4 wow reveal fadeInUp'>
                            <button type='button' className='orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase' onClick={handleBookAppointment}>Schedule Service</button>
                        </div>
                        <div className='text-center wow reveal fadeInUp'>
                            <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                (813) 588-0905
                            </a>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-car-wrap'>
                <div className='container'>
                    <div className='row align-items-center'>
                        <div className='col-lg-6 wow reveal fadeInLeft'>
                            {/* <div className='md-title fw-700 text-uppercase mb-md-4 mb-3'>Exotic Cars Services in <br />Tampa, FL</div> */}
                            <div className='md-title fw-700 text-uppercase mb-md-4 mb-3'>{getCMSValue('serviceExoticCarsHeading')}</div>
                            <div className='common-text'>
                                <p>{getCMSValue('serviceExoticCarstext')}</p>
                            </div>
                        </div>
                        <div className='col-lg-6 text-lg-end text-center mt-lg-0 mt-5 wow reveal fadeInRight'>
                            <img src={getImages('exotic-img.png')} alt='service' />
                        </div>
                    </div>
                </div>
            </section>
            <section className='offer-exotic-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6 pe-lg-5 pt-2 wow reveal fadeInLeft'>
                            <div className='sm-title text-uppercase font-1-9em mb-md-4 mb-3'>{getCMSValue('serviceWeOfferHeading')}</div>
                            <div className='common-text'>
                                <p>{getCMSValue('serviceWeOfferText1')}</p>

                                <p>{getCMSValue('serviceWeOfferText2')}</p>
                            </div>
                        </div>
                        <div className='col-lg-6 wow mt-lg-0 mt-5 reveal fadeInRight'>
                            <ul className='oe-list-flex'>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard1Text')}</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard2Text')}</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard3Text')}</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard4Text')}</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard5Text')}</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard6Text')}</div>
                                    </div>
                                </li>
                                <li>
                                    <div className='d-flex align-items-center'>
                                        <div className='oe-icon'>
                                            <img src={getImages('arrow.svg')} />
                                        </div>
                                        <div className='sm-title eurostile text-uppercase pt-1'>{getCMSValue('serviceWeOffercard7Text')}</div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <section className='offer-exotic-wrap skilled-exotic-wrap'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-6 pe-lg-5 wow reveal fadeInLeft'>
                            {/* <div className='md-title font-1-9em text-orange eurostile fw-400 text-uppercase mb-md-4 mb-3'>Skilled Technicians, Competitive <br />Pricing</div> */}
                            <div className='md-title font-1-9em text-orange eurostile fw-400 text-uppercase mb-md-4 mb-3'>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: getCMSValue('serviceSkilled1Title'),
                                    }}
                                />
                            </div>
                            <div className='common-text'>
                                <p>{getCMSValue('serviceSkilled1Text')}</p>
                            </div>
                        </div>
                        <div className='col-lg-6 ps-lg-5 mt-lg-0 mt-5 wow reveal fadeInRight'>
                            {/* <div className='md-title font-1-9em text-orange eurostile fw-400 text-uppercase mb-md-4 mb-3'>Factory-Authorized Koenigsegg <br />Service Center</div> */}
                            <div className='md-title font-1-9em text-orange eurostile fw-400 text-uppercase mb-md-4 mb-3'>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: getCMSValue('serviceAuthorized1Title'),
                                    }}
                                /></div>
                            <div className='common-text'>
                                <p>{getCMSValue('serviceAuthorized1Text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='brand-service-wrap'>
                <div className='container'>
                    <div className='md-title font-2-5em text-uppercase bs-before w-100 text-center mb-4 wow reveal fadeInUp'><span>{getCMSValue('serviceBrandHeading')}</span></div>
                    <div className='sm-title text-center mb-4 text-uppercase wow reveal fadeInUp'>{getCMSValue('serviceBrandSubHeading')}</div>
                    <div className='brand-service-logos d-flex flex-wrap mb-md-5 mb-4 wow reveal fadeInUp'>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/ferrari.png')} alt='ferrari' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/lambo.png')} alt='lambo' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/maserati.png')} alt='maserati' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/benz.png')} alt='benz' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/porsche.png')} alt='porsche' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/bentley.png')} alt='bentley' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/koenigsegg.png')} alt='koenigsegg' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/rolls-royce.png')} alt='rolls royce' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/mclaren.png')} alt='mclaren' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/aston-martin.png')} alt='aston martin' />
                        </div>
                        <div className='brand-logo-item'>
                            <img src={getImages('logos/audi.png')} alt='audi' />
                        </div>
                    </div>
                    {/* <div className='brand-text text-center wow reveal fadeInUp'>Whether you're located in Tampa, Orlando, or even distant cities like Las Vegas, Los Angeles, or San Diego, drivers trust European <br />Exotic Center for their exotic car service needs.</div> */}
                    <div className='brand-text text-center wow reveal fadeInUp'>{getCMSValue('serviceBrandText')}</div>
                </div>
            </section>
            <section className='book-appointment-wrap'>
                <div className="mouse-container"
                    onMouseMove={handleMouseMove}>
                    <motion.div
                        className="mouse-background"
                        style={{
                            background: `url(${getImages('book-appointment-bg.webp')}) no-repeat center/cover`
                        }}
                        animate={{
                            x: position.bgX,
                            y: position.bgY,
                        }}
                        transition={{ type: "tween", stiffness: 50 }}
                    />
                    <div className='w-100 text-center mouse-text'>
                        <div className='container'>
                            <div className='banner-lg-title font-3-5em text-uppercase wow reveal fadeInUp'>{getCMSValue('serviceScheduleHeading')}</div>
                            <div className='sm-title font-1-2em mt-3 wow reveal fadeInUp'>{getCMSValue('serviceScheduleSubHeading')}</div>
                            <div className="my-4 wow reveal fadeInUp">
                                <button type="button" className="orange-white-btn lg-btn w-330 font-1-2em fw-700 text-uppercase" onClick={handleBookAppointment}>Schedule Service</button>
                            </div>
                            <div className='text-center wow reveal fadeInUp'>
                                <a href='tel:8135880905' className='sm-title font-1-5em fw-400 avenir-next text-white'>
                                    Or Call (813) 588-0905
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='exotic-vehicle-wrap'>
                <div className='container'>
                    <div className='lg-title font-2-5em fw-700 text-uppercase mb-4 wow reveal fadeInUp'>{getCMSValue('serviceExoticHeading')}</div>
                    <div className='common-text wow reveal fadeInUp'>
                        <p>{getCMSValue('serviceExoticText1')}</p>
                        <div className='md-title font-1-9em text-orange eurostile fw-400 text-uppercase mt-4 mb-2'>{getCMSValue('serviceExoticSubHeading')}</div>
                        <p>{getCMSValue('serviceExoticText2')}</p>
                    </div>
                </div>
            </section>
            {openBookAppointment &&
                <ModalLayout open={openBookAppointment} close={closeBookAppointment} darkThemeCls='true' modalWidth={1030}>
                    <BookAppointmentModal close={closeBookAppointment} />
                </ModalLayout>
            }
        </>
    )
}

export default Service